module.exports = __webpack_public_path__ + "static/media/Login_Page.c98ffb22.jpg";